<template>
  <component :is="props.is" v-bind="props">
    <p class="my-1 font-weight-bold">
      {{ label }} <slot name="append-content" />
    </p>
    <slot />
  </component>
</template>
<script setup lang="ts">
import { type Component } from 'vue'

type ContainerWithLabelProps = {
  label: string
  is?: string | Component
}

const props = withDefaults(defineProps<ContainerWithLabelProps>(), {
  is: 'v-sheet',
})
</script>
